import { render, staticRenderFns } from "./faceswitch.vue?vue&type=template&id=761583f1"
import script from "./faceswitch.vue?vue&type=script&lang=js"
export * from "./faceswitch.vue?vue&type=script&lang=js"
import style0 from "./faceswitch.vue?vue&type=style&index=0&id=761583f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports